"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Prescription = void 0;
class Prescription {
    constructor(props) {
        this.consumed = props?.consumed || false;
        this.country = props?.country || null;
        this.date = props?.date || null;
        this.diagnosis = props?.diagnosis || null;
        this.entity = props?.entity || null;
        this.hc = props?.hc || null;
        this.items = props?.items || [];
        this.medical_record_id = props?.medical_record_id || null;
        this.patient = props?.patient || null;
        this.prescription_number = props?.prescription_number || null;
        this.provider = props?.provider || null;
        this.response = props?.response || null;
        this.status = props?.status || null;
        this.timestamps = props?.timestamps || null;
        this.type = props?.type || null;
        this.uid = props?.uid || null;
        this.validator = props?.validator || null;
    }
}
exports.Prescription = Prescription;
